/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const campaignAddonDataSchema = z.object({
	id: z.string(),
	name: z.string(),
	selected: z.boolean(),
	price: z.number().nullable(),
})

export type CampaignAddonDataSchema = z.infer<typeof campaignAddonDataSchema>
